// import './sections/main-product.js';
window.setTimeout(function() {
    const navLinks = document.querySelectorAll('.mega-menu__list--tabs div:has(button)');
    console.log(navLinks);
    navLinks.forEach(link => {
        link.addEventListener('mousedown', function() {
            let hasDisabledButton = link.querySelector('button[disabled]');
            if (hasDisabledButton) {
                let url = link.dataset.link;
                window.location.href = url;
            }
        })
    })

}, 2000)




// bundles
const bundlesInputs = document.querySelectorAll('.upsell-products input');
bundlesInputs.forEach(input => {
    input.addEventListener('change', function() {
        const form = input.closest('.upsell-products').closest('product-info').querySelector('product-info > .product-form-wrapper form');
        const parent = this.closest('.upsell-products').closest('product-info');

        const items =  Array.from(parent.querySelectorAll('input[name="bundles"]:checked'));

        const event = new CustomEvent('bundle:change', {
            detail: {
                items: items.map(input => ({
                    id: input.value,
                    quantity: 1,
                    price: input.getAttribute('data-price')
                }))
            }
        });
        form.dispatchEvent(event);
    })
})